var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 19C6.27983 19 4.94824 17.6684 4.94824 16.0312C4.94824 15.7035 5.21424 15.4375 5.54199 15.4375C5.86974 15.4375 6.13574 15.7035 6.13574 16.0312C6.13574 17.0138 6.93461 17.8125 7.91699 17.8125C8.89952 17.8125 9.69824 17.0138 9.69824 16.0312C9.69824 15.7035 9.96424 15.4375 10.292 15.4375C10.6197 15.4375 10.8857 15.7035 10.8857 16.0312C10.8857 17.6684 9.55415 19 7.91699 19Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4479 16.625H1.38537C0.621437 16.625 0 16.0036 0 15.2396C0 14.8342 0.176559 14.4503 0.484451 14.1866C1.68862 13.1693 2.375 11.6906 2.375 10.1239V7.91662C2.375 4.86089 4.86089 2.375 7.91662 2.375C10.9725 2.375 13.4584 4.86089 13.4584 7.91662V10.1239C13.4584 11.6906 14.1448 13.1693 15.341 14.1811C15.6568 14.4503 15.8334 14.8342 15.8334 15.2396C15.8334 16.0036 15.2119 16.625 14.4479 16.625ZM7.91662 3.5625C5.51552 3.5625 3.5625 5.51552 3.5625 7.91662V10.1239C3.5625 12.0404 2.72261 13.8502 1.25882 15.0876C1.23099 15.1113 1.1875 15.1605 1.1875 15.2396C1.1875 15.3472 1.27781 15.4375 1.38537 15.4375H14.4479C14.5556 15.4375 14.6459 15.3472 14.6459 15.2396C14.6459 15.1605 14.6022 15.1113 14.5762 15.0892C13.1108 13.8502 12.2709 12.0404 12.2709 10.1239V7.91662C12.2709 5.51552 10.3179 3.5625 7.91662 3.5625Z",
    fill: "#3CB4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 3.5625C7.58924 3.5625 7.32324 3.2965 7.32324 2.96875V0.59375C7.32324 0.265999 7.58924 0 7.91699 0C8.24474 0 8.51074 0.265999 8.51074 0.59375V2.96875C8.51074 3.2965 8.24474 3.5625 7.91699 3.5625Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconBlue);
export default __webpack_public_path__ + "static/media/bellIconBlue.062bf1670a7f21845ff0acd727ede1f6.svg";
export { ForwardRef as ReactComponent };